import {appHeaderActionTypes} from "./actionTypes"

export function setPrevRoute(prevRoute) {
    return {
        type: appHeaderActionTypes.SET_PREV_ROUTE,
        payload: prevRoute
    }
}
